import { Component } from '@angular/core';
import { FuseConfigService } from '../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../core/animations';

/**Local file */
import { spekwo, register } from '../../utils/index';

@Component({
    selector: 'registration-main',
    templateUrl: './registeration.component.html',
    styleUrls: ['./registeration.component.scss'],
    animations: fuseAnimations
})

export class RegisterationComponent {

    spekwoValues = spekwo;
    registerValues = register;

    constructor(
        private fuseConfig: FuseConfigService,
    ) {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });
    }

    ngOnInit() {
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/authentication/registration/registeration.component.ts